import { useTheme } from '@/components/theme-provider'
import { cn } from '@/lib/utils'

// Unisys logo that swaps by theme. `onDark` forces the reverse (white) logo
// regardless of theme (e.g. on the dark sidebar rail or a brand gradient).
export function Logo({ className, onDark }: { className?: string; onDark?: boolean }) {
    const { theme } = useTheme()
    const reverse = onDark || theme === 'dark'
    const src = reverse ? '/Unisys_Logo_Reverse_RGB.png' : '/Unisys_Logo_Color_RGB.png'
    return <img src={src} alt="Unisys" className={cn('h-8 w-auto select-none', className)} draggable={false} />
}
